// components
import { HistoryComponent } from './history.component';

export const HISTORY_COMPONENTS: any[] = [
  HistoryComponent,
];

// services



// WEBPACK FOOTER //
// ./src/app/components/dashboard/history/index.ts